import {
  isDeviceAndroid,
  isDeviceIos
} from '@/modules/shared/utils/deviceDetections';
import shippingEvents from '@/modules/shared/utils/gtmEvents/events/shippingEvents';
import { sendGtmEvent } from '@/modules/shared/utils/gtmEvents/Manager';
import {
  type SendGtmEvent,
  type ShippingEvent
} from '@/modules/shared/utils/gtmEvents/types';

import { sendAndroidEvent, sendIosEvent } from './sendWebViewEvents';

export function sendEvent({ event, extraFields }: SendGtmEvent): void {
  try {
    const eventObj: ShippingEvent = {
      ...shippingEvents[event],
      ...(extraFields || {})
    };

    if (isDeviceIos()) return sendIosEvent(event, eventObj);

    if (isDeviceAndroid()) return sendAndroidEvent(event, eventObj);

    return sendGtmEvent(eventObj);
  } catch (error) {
    console.error(`GTM: Couldn't send ${event} event`, error);
  }
}
